module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page.be72549e.png";